// extracted by mini-css-extract-plugin
export default {"title":"PageTitle_title__WiRkb","uppercase":"PageTitle_uppercase__sz21X"};